import { BrowserRouter, Route, Routes } from 'react-router-dom'
import BookingWidget from './components/BookingWidget'
import CancelBooking from './pages/CancelBooking'
import RescheduleBooking from './pages/RescheduleBooking'

const App = () => (
  <BrowserRouter>
    <div
      className="flex min-h-screen items-start justify-center px-4 py-10 text-widget-accent md:items-center"
      style={{
        background:
          'linear-gradient(180deg, rgba(var(--widget-primary-rgb, 26 31 58), 1) 0%, rgba(var(--widget-primary-rgb, 26 31 58), 0.85) 60%, rgba(var(--widget-primary-rgb, 26 31 58), 1) 100%)',
      }}
    >
      <Routes>
        <Route path="/" element={<BookingWidget />} />
        <Route path="/cancel" element={<CancelBooking />} />
        <Route path="/reschedule" element={<RescheduleBooking />} />
      </Routes>
    </div>
  </BrowserRouter>
)

export default App
